@import "../../../global/gx-ide-mixins.scss";

$file-item-actions-inline-size: 40px;

:host {
  display: block;
}

.file-item {
  display: grid;
  column-gap: var(--spacing-gap-l);
  row-gap: var(--spacing-gap-s);
  align-items: center;
  border-radius: var(--border-radius-s);
  
  &--without-actions {
    grid-template-columns: max-content 1fr;
    grid-template-areas: "icon name";
  }
  &--with-actions {
    grid-template-columns: max-content 1fr max-content;
    grid-template-areas: "icon name actions";
  }

  &__icon {
    display: flex;
    align-items: center;
    grid-area: icon;
    padding-block: calc(32px - var(--ch-image-size)); // prevent layout shift when file-item__actions are displayed
  }

  &__name {
    grid-area: name;
    @include ellipsis;
    min-inline-size: 0;

    ch-edit {
      @include ellipsis;
    }

    .label {
      @include ellipsis;
    }
  }

  &__actions {
    grid-area: actions;
    display: flex;
  }

  &__cancel-upload {
    transform: translateX(7px);
  }

  &__progress-container {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-gap-xs);
    border: 2px dashed var(--color-border-neutral-default);
    border-radius: var(--border-radius-m);
    padding: var(--spacing-padding-xxs) var(--spacing-padding-l) var(--spacing-padding-m) var(--spacing-padding-l);
  }

  &__progress-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--spacing-gap-l);
  }

  &__uploading-text {
    color: var(--color-text-neutral-disabled);
    @include ellipsis;
    max-inline-size: calc(100% - #{$file-item-actions-inline-size});
  }

  &__progress-bar {
    progress {
      block-size: 8px;
      line-height: 0;
      border: none;
      border-radius: var(--border-radius-s);
      overflow: hidden;

      &::-webkit-progress-bar {
        background-color: transparent;
      }

      &::-webkit-progress-value {
        background-color: var(--color-accent-primary-default);
      }

      &::-moz-progress-bar {
        background-color: var(--color-accent-primary-default);
      }
    }
  }
}
